import * as tslib_1 from "tslib";
import * as React from 'react';
import { Icon } from '../../Icon';
import { classNamesFunction } from '../../Utilities';
var getClassNames = classNamesFunction();
var CheckBase = /** @class */function (_super) {
  tslib_1.__extends(CheckBase, _super);
  function CheckBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CheckBase.prototype.render = function () {
    var _a = this.props,
      checked = _a.checked,
      className = _a.className,
      theme = _a.theme,
      styles = _a.styles;
    var classNames = getClassNames(styles, {
      theme: theme,
      className: className,
      checked: checked
    });
    return React.createElement("div", {
      className: classNames.root
    }, React.createElement(Icon, {
      iconName: "CircleRing",
      className: classNames.circle
    }), React.createElement(Icon, {
      iconName: "StatusCircleCheckmark",
      className: classNames.check
    }));
  };
  CheckBase.defaultProps = {
    checked: false
  };
  return CheckBase;
}(React.PureComponent);
export { CheckBase };